import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import Sidebar from "./Sidebar"; 

// ✅ Import your logo image
import LogoImg from "../../assets/svg/Logo.png"; // adjust path to your logo

export default function TopNavbar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <NavBar>
        <LogoWrapper>
          <img src={LogoImg} alt="Sama Al Falah Logo" className="logo" />
        
        </LogoWrapper>

        {/* Desktop Nav */} 
        <NavLinks>
          <NavItem><Link to="home" smooth duration={500}>Home</Link></NavItem>
              <NavItem><Link to="services" smooth duration={500}>Services</Link></NavItem>
          <NavItem><Link to="about" smooth duration={500}>About Us</Link></NavItem>
      
        {/* //  <NavItem><Link to="contact" smooth duration={500}>Contact Us</Link></NavItem> */}
        </NavLinks>

        {/* Mobile Hamburger */}
        <Hamburger onClick={() => setSidebarOpen(!sidebarOpen)} open={sidebarOpen}>
          <span />
          <span />
          <span />
        </Hamburger>
      </NavBar>

      {/* Sidebar Component */}
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={setSidebarOpen} />
    </>
  );
}

// =================== Styles ===================
const NavBar = styled.nav`
  width: 100%;
  background: #fff;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

// ✅ New logo wrapper
const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .logo {
    width: 80px; /* adjust size */
    height: auto;
  }

  span {
    font-size: 1.25rem;
    font-weight: 700;
    color: #0b093b;
  }
`;

const NavLinks = styled.ul`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavItem = styled.li`
  list-style: none;

  a {
    text-decoration: none;
    font-weight: 600;
    color: #0b093b;
    transition: 0.3s ease;
    cursor: pointer;

    &:hover {
      color: #7620ff;
    }
  }
`;

const Hamburger = styled.button`
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 28px;
  height: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1200;
  transition: transform 0.2s ease;

  span {
    height: 3px;
    width: 100%;
    background: #0b093b;
    border-radius: 2px;
    transition: 0.3s ease;
    transform-origin: center;
  }

  ${({ open }) =>
    open &&
    `
      span:nth-child(1) {
        transform: rotate(45deg) translate(5px, 5px);
      }
      span:nth-child(2) {
        opacity: 0;
      }
      span:nth-child(3) {
        transform: rotate(-45deg) translate(5px, -5px);
      }
    `}

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;
